import React, {useEffect, useState} from 'react';
import ContainerComponent from '../../helpers/components/container.component';
import {useHistory, useParams} from 'react-router-dom';
import useAccess from '../../helpers/hooks/useAccess';
import { useDispatch } from 'react-redux';
import AccessContext from '../../helpers/context/access.context';
import ActivityService from "../../services/ewallet_integration/activity.service";
import RedemptionDetail from "./components/redemption_detail";
import {Button, Col, Divider, Row} from "antd";
import globalHelper from "../../helpers/functions/global.helper";
import TopupDetail from "./components/topup_detail";
import PaymentDetail from "./components/payment_detail";
import RefundDetail from "./components/refund_detail";
import MerchantSettlementDetail from "./components/merchant_settlement_detail";

const ActivityDetail = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const { activity_id } = useParams();
    const access = useAccess("/activities");
    const [activity , setActivity] = useState({});

    const load = async () => {
        const activityResponse = await ActivityService.activity_detail(activity_id);
        if (activityResponse) {
            const {activity} = activityResponse.data;
            setActivity(activity);
        }
    }


    // Load activities on first render or when search changes
    useEffect(() => {
        load(); // reset to page 1 on search change
    }, [activity_id]);
    return (
        <>
            <ContainerComponent span={20} top={20} bottom={20}>
                <AccessContext.Provider value={access}>
                    {(() => {
                        switch (activity?.transaction_type?.code) {
                            case 'TOPUP':
                                return <TopupDetail activity={activity} />;
                            case 'REDEMPTION':
                                return <RedemptionDetail activity={activity} />;
                            case 'REFUND':
                                return <RefundDetail activity={activity} />;
                            case 'PAYMENT':
                                return <PaymentDetail activity={activity} />;
                            case 'SETTLEMENT':
                                return <MerchantSettlementDetail activity={activity} />;
                            default:
                                // return <DefaultComponent activity={activity} />;
                        }
                    })()}
                    <Divider />
                    <div style={{display : 'flex',}}>
                        <div {...globalHelper?.isMobileScreen() ? ({ style : { width : '100%', } }) : ({ style : { marginLeft : 'auto',} })}>
                            <Row gutter={8}>
                                <Col span={12}>
                                    <Button onClick={() => history.goBack()} style={{ width : '100%', minWidth : 150 }}>Back</Button>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </AccessContext.Provider>
            </ContainerComponent>
        </>
    );
}

export default ActivityDetail;